import React from "react";
import { TableHead, TableRow } from "@material-ui/core";

import {
  ButtonTableCell,
  StyledTableCell
} from "../../../components/sharedStyledComponents";

export const UserBySubTableHeader: React.FunctionComponent = () => (
  <TableHead>
    <TableRow>
      <StyledTableCell>Email</StyledTableCell>
      <StyledTableCell>Roles</StyledTableCell>
      <ButtonTableCell />
    </TableRow>
  </TableHead>
);
